import React, { FC } from 'react';
import FlexGroup from './FlexGroup';
import FlexItem from './FlexItem';

interface NavigationLayoutProps {
  header: React.ReactNode;
  content: React.ReactNode;
  footer: React.ReactNode;
}

const NavigationLayout: FC<NavigationLayoutProps> = ({ header, content, footer }) => {
  return (
    <div style={{ display: 'contents' }} data-testid="navigation-layout">
      <FlexGroup padding="0" gapSize="0" alignItems="space-between">
        <FlexItem>
          <FlexGroup padding="2" direction="column" justifyContent="flex-start" gapSize="2">
            <FlexItem grow="0" shrink="0">
              {header}
            </FlexItem>

            <FlexItem grow="1" shrink="1">
              <FlexGroup direction="column" padding="0" gapSize="6">
                {content}
              </FlexGroup>
            </FlexItem>

            <FlexItem grow="0" shrink="0">
              <>{footer}</>
            </FlexItem>
          </FlexGroup>
        </FlexItem>
      </FlexGroup>
    </div>
  );
};

export default NavigationLayout;
